import apiClient from "./apiClient"
import { UnknownRecord } from "../models/api"

export async function recordPayment(
    companyId: string,
    saleId: string,
    payload: UnknownRecord
): Promise<UnknownRecord> {
    const normalized: UnknownRecord = { ...(payload || {}) }

    if (!normalized.amount && Number.isInteger(normalized.amountMinor)) {
        normalized.amount = {
            currency: normalized.currency || "EUR",
            amountMinor: normalized.amountMinor,
        }
    }

    if (
        normalized.amountTenderedMinor == null &&
        Number.isInteger(normalized.amount_tendered_minor)
    ) {
        normalized.amountTenderedMinor = normalized.amount_tendered_minor
    }

    return apiClient.post(
        `/api/companies/${companyId}/sales/${saleId}/payments`,
        normalized
    )
}

export async function reversePayment(
    companyId: string,
    saleId: string,
    paymentId: string
): Promise<UnknownRecord> {
    return apiClient.post(
        `/api/companies/${companyId}/sales/${saleId}/payments/${paymentId}/reverse`
    )
}

const paymentsService = {
    recordPayment,
    reversePayment,
}

export default paymentsService
